export const CLASS_TODO_LIST_CHECKED = 'slate-TodoListElement-rootChecked';
